export const APP_PATH = process.env.NODE_ENV === 'production' ? '/' : '/'
export const ROOT_PATH = '/'
export const NEW_PATH = '/new'
export const LOGIN_PATH = '/login'
export const ACCOUNT_PATH = '/account'
export const PROJECT_PATH = '/project'
export const DASHBOARD = '/dashboard'
export const PATIENTS = '/patients'
export const DOCTORS = '/doctors'
export const NURSES = '/nurses'
export const ALERTS = '/alerts'
export const HELP = '/help'
export const NEW_PATIENT = '/patients/new'
export const NEW_DOCTOR = '/doctors/new'
export const NEW_NURSE = '/nurses/new'
